import { Card } from "@/components/ui/card";

import { CountdownCircle } from "./CountdownCircle";

type WordCardProps = {
  countdown: number;
  word: string;
};

function WordCard({ countdown, word }: WordCardProps) {
  return (
    <Card className="relative w-full bg-white flex items-center justify-center min-h-40">
      {/* 카운트다운 원 */}
      <div className="absolute z-10 left-3 top-3">
        <CountdownCircle countdown={countdown} />
      </div>

      {/* 단어 */}
      <span className="text-4xl font-extrabold text-tertiary tracking-wide">{word}</span>
    </Card>
  );
}

export default WordCard;
